import React from 'react';
import ApplyContainer from '../../Componant/JobSearch/Apply';

const Apply = () => {
  return (
    <div className='page-body'>
      <ApplyContainer />
    </div>
  );
};

export default Apply;
